<ion-grid class="filter">
  <ion-row
    class="filter__container"
    [ngStyle]="{
      gap: filterStyles[1] + '%'
    }"
  >
    <ion-col
      [ngStyle]="{
        'flex-basis': filterStyles[0] + '%',
        'min-width': filterStyles[0] + '%'
      }"
    >
      <ng-container *ngIf="latestFilterGoupModel.groups.length">
        <ion-row class="filter__items" [ngClass]="{ 'filter__items--no-wrap': scrollableX }">
          <ng-content select="[custom-filters]"></ng-content>
          <ng-container *ngFor="let filterGroup of latestFilterGoupModel.groups; let filterIndex = index">
            <ion-col size="auto">
              <ng-container *ngIf="filterGroup.type === 'SELECT_FILTER'">
                <monorepo-inline-multi-select-depr
                  [popoverRenderOptionType]="renderOptionType"
                  [inlineMultiSelectInput]="filterGroup"
                  [selectedFilters]="latestFilterGoupModel.selectedFilters"
                  (selectedItemsEvent)="updateByGroupInfo($event)"
                ></monorepo-inline-multi-select-depr>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'MULTI_SELECT_FILTER'">
                <monorepo-inline-multi-select
                  [popoverRenderOptionType]="renderOptionType"
                  [inlineMultiSelectInput]="filterGroup"
                  (selectedItemsEvent)="updateByGroupInfo($event)"
                ></monorepo-inline-multi-select>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'SINGLE_SELECT_FILTER'">
                <monorepo-inline-single-select
                  [inlineSingleSelectInput]="filterGroup"
                  [popoverRenderOptionType]="renderOptionType"
                  (selectedItemEvent)="updateByGroupInfo($event)"
                ></monorepo-inline-single-select>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'DATE_FILTER'">
                <ui-select [filterModel]="filterGroup" (selectedFilterEvent)="updateByGroupInfo($event)"></ui-select>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'TARGET_DATE_FILTER'">
                <div class="target-date-filter" id="targetDate">{{ filterGroup.displayName }}</div>
                <ion-popover trigger="targetDate">
                  <ng-template>
                    <ng-container *ngIf="filterGroup.values.length === 2; else withoutMinMax">
                      <ion-datetime
                        presentation="date"
                        [showDefaultButtons]="true"
                        id="datetime"
                        (ionChange)="onTargetDateChange($event, filterGroup)"
                        [min]="filterGroup.values[0]"
                        [max]="filterGroup.values[1]"
                      ></ion-datetime>
                    </ng-container>
                    <ng-template #withoutMinMax>
                      <ion-datetime
                        presentation="date"
                        [showDefaultButtons]="true"
                        id="datetime"
                        (ionChange)="onTargetDateChange($event, filterGroup)"
                      ></ion-datetime>
                    </ng-template>
                  </ng-template>
                </ion-popover>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'SEARCH_FILTER'">
                <ui-search-filter
                  [filterModel]="filterGroup"
                  (searchQueryEvent)="updateByGroupInfo($event)"
                ></ui-search-filter>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'DURATION_FILTER'">
                <ui-custom-button
                  [buttonType]="'QUATERNARY'"
                  [iconSrc]="'assets/common/chevron-close-block.svg'"
                  [iconPlacement]="'AFTER'"
                  [btnTxt]="filterGroup.displayName ? filterGroup.displayName : ('filter.Duration' | translate)"
                  (clickEvent)="openDurationFilter(filterGroup)"
                ></ui-custom-button>
              </ng-container>
              <ng-container *ngIf="filterGroup.type === 'ORG_HIERARCHY_FILTER'">
                <ui-custom-button
                  [buttonType]="'QUATERNARY'"
                  [btnTxt]="filterGroup.displayName"
                  [isDisabled]="!filterGroup.hierarchy.values.length"
                  (clickEvent)="openOrgHeirarchyPopover($event, filterGroup.hierarchy, filterGroup)"
                ></ui-custom-button>
              </ng-container>
            </ion-col>
          </ng-container>
        </ion-row>

        <ion-row *ngIf="latestFilterGoupModel.hasSelectedFilters" class="filter__selection">
          <ng-container *ngFor="let groupItem of latestFilterGoupModel.groups">
            <ng-container *ngIf="groupItem.type === 'SELECT_FILTER'">
              <ng-container *ngIf="groupItem.selectedValues.length">
                <ng-container *ngFor="let filterVal of groupItem.selectedValues">
                  <ui-label
                    [displayStr]="filterVal"
                    (removeFilterEvent)="removeFilter(filterVal, groupItem)"
                  ></ui-label>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="groupItem.type === 'MULTI_SELECT_FILTER'">
              <ng-container *ngIf="groupItem.selectedValues.length">
                <ng-container *ngFor="let filterVal of groupItem.selectedValues">
                  <ui-label
                    [displayStr]="filterVal.displayName"
                    [preTagForDataDisplay]="groupItem.preTagForDataDisplay"
                    (removeFilterEvent)="removeFilter(filterVal.value, groupItem)"
                  ></ui-label>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="groupItem.type === 'SINGLE_SELECT_FILTER'">
              <ng-container *ngIf="groupItem.selectedValue">
                <ui-label
                  [displayStr]="groupItem.selectedValue.value"
                  (removeFilterEvent)="removeFilter('', groupItem)"
                ></ui-label>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="groupItem.type === 'DURATION_FILTER'">
              <ng-container *ngFor="let item of groupItem.items">
                <ui-label
                  *ngIf="item.isSelected && item.value.type !== 'CUSTOM'"
                  [displayStr]="item.value.type"
                  (removeFilterEvent)="removeFilter('', groupItem)"
                ></ui-label>
                <ui-label
                  *ngIf="item.isSelected && item.value.type === 'CUSTOM'"
                  [displayStr]="item.value.displayString || item.value.type"
                  (removeFilterEvent)="removeFilter('', groupItem)"
                ></ui-label>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="groupItem.type === 'DATE_FILTER'">
              <ng-container *ngFor="let item of groupItem.items">
                <ui-label
                  *ngIf="item.isSelected"
                  [displayStr]="item.displayText || ''"
                  (removeFilterEvent)="removeFilter(item.value, groupItem)"
                ></ui-label>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="groupItem.type === 'TARGET_DATE_FILTER'">
              <span *ngIf="!!groupItem.selectedValues.length">
                <ui-label
                  [displayStr]="groupItem.selectedValues[0]"
                  [type]="'DATE'"
                  (removeFilterEvent)="removeFilter('', groupItem)"
                ></ui-label>
              </span>
            </ng-container>

            <ng-container *ngIf="groupItem.type === 'SEARCH_FILTER'">
              <span *ngIf="!!groupItem.text">
                <ui-label
                  [displayStr]="groupItem.text"
                  (removeFilterEvent)="removeFilter(groupItem.text, groupItem)"
                ></ui-label>
              </span>
            </ng-container>

            <ng-container *ngIf="groupItem.type === 'ORG_HIERARCHY_FILTER'">
              <span *ngIf="!!groupItem.filteredOrgTree.values.length">
                <ui-label
                  [displayStr]="'mapping_wip_level.org_fil_sel' | translate"
                  (removeFilterEvent)="removeFilter('', groupItem)"
                ></ui-label>
              </span>
            </ng-container>
          </ng-container>
          <span class="clear-all-filter" (click)="clearAllFilters()">{{ 'filter.ClearAll' | translate }}</span>
        </ion-row>
      </ng-container>
      <ion-row>
        <ng-content select="[pagination]"></ng-content>
        <ng-content select="[sorter]"></ng-content>
      </ion-row>
    </ion-col>

    <ion-col
      [ngStyle]="{
        'flex-basis': filterStyles[2] + '%',
        'min-width': filterStyles[2] + '%'
      }"
    >
      <ion-row class="filter__bulk-actions ion-text-right">
        <ng-content select="[bulk-table-action]"></ng-content>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
